module.exports = __webpack_public_path__ + "img/Y2KYP2.255067af.jpg";